/**
 * Google Tag Manager E-commerce tracking functions
 */
(function($) {
    'use strict';
    
    // Track add to cart events
    $(document).on('added_to_cart', function(event, fragments, cart_hash, $button) {
        if (typeof dataLayer === 'undefined') return;
        
        // Get product data from the button's data attributes
        var productId = $button.data('product_id');
        var productSku = $button.data('product_sku');
        var productName = $button.data('product_name');
        var productPrice = $button.data('product_price');
        var productCategory = $button.data('product_category');
        var quantity = $button.data('quantity') || 1;
        
        // Push add_to_cart event to dataLayer for GTM
        dataLayer.push({
            'event': 'add_to_cart',
            'ecommerce': {
                'items': [{
                    'item_id': productSku || productId,
                    'item_name': productName,
                    'item_category': productCategory,
                    'price': productPrice,
                    'currency': globberAnalytics.currency,
                    'quantity': quantity
                }]
            }
        });
    });
    
    // Track begin_checkout events
    $(document.body).on('wc_proceed_to_checkout', function() {
        if (typeof dataLayer === 'undefined') return;
        
        dataLayer.push({
            'event': 'begin_checkout',
            'ecommerce': {
                'currency': globberAnalytics.currency,
                'value': globberAnalytics.cartTotal,
                'items': globberAnalytics.cartItems
            }
        });
    });
    
})(jQuery);